//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GoodsSet from'./router_link/goodsSet.vue'
// import GoodsSeries from'./router_link/goodsSeries.vue'
// import GoodsType from'./router_link/goodsType.vue'
export default {
  components:{
    // GoodsType,GoodsSeries,
    GoodsSet
  },
  data() {
    return {
      rules: {},
      form: {
        day: undefined
      },
      // componentId :''
    }
  },
}
